/**
 * LimitReasonLine — self-serve only.
 * The amber 11.5 px reason line under a greyed control (UI-SPEC §6.2, §4.10).
 * Renders nothing when reason and left are both absent / empty.
 *
 * The control's greyed state is the CALLER's responsibility (refused flag,
 * a 409, or needRowsReason); this component only renders the reason text.
 *
 * @see B-popup-frontend.md step 7, Files and props § LimitReasonLine
 */
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { slotText } from './promptStudioModel';
import type { LimitSlot } from './promptStudioModel';

export interface LimitReasonLineProps {
  reason?: LimitSlot | null;
  left?: LimitSlot[];
}

export function LimitReasonLine({ reason, left }: LimitReasonLineProps) {
  const { t } = useTranslation();
  if (!reason && (!left || left.length === 0)) return null;
  return (
    <Box sx={{ fontSize: 11.5, color: '#b45309', mt: 0.5 }}>
      {reason && <Box>{slotText(t, reason)}</Box>}
      {left?.map((s, i) => (
        <Box key={i}>{slotText(t, s)}</Box>
      ))}
    </Box>
  );
}
